import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectThemeMode, setThemeMode, ThemeMode } from './themeSlice';

export const useTheme = () => {
  const dispatch = useAppDispatch();
  const themeMode = useAppSelector(selectThemeMode);

  // Apply theme changes to the DOM
  useEffect(() => {
    const root = document.documentElement;
    
    if (themeMode === 'auto') {
      // Auto mode: follow system preference
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const applyAutoTheme = () => {
        if (mediaQuery.matches) {
          root.classList.add('dark');
        } else {
          root.classList.remove('dark');
        }
      };
      
      // Apply immediately
      applyAutoTheme();
      
      // Listen for system theme changes
      mediaQuery.addEventListener('change', applyAutoTheme);
      
      return () => {
        mediaQuery.removeEventListener('change', applyAutoTheme);
      };
    } else if (themeMode === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [themeMode]);

  const changeTheme = (mode: ThemeMode) => {
    dispatch(setThemeMode(mode));
  };

  return {
    themeMode,
    changeTheme,
  };
};
